export default "__VITE_ASSET__26b7f9d3__"